import Image from "next/image";

import { twMerge } from "tailwind-merge";

const SummariseButton = ({
  url,
  onSummarise,
  isLoading,
  allowSummarization,
}: {
  url: string;
  onSummarise?: (_url: string) => void;
  isLoading?: boolean;
  hasSummary?: boolean;
  allowSummarization?: boolean;
}) => {
  return (
    <button
      className={twMerge(
        "flex items-center justify-center border-0 w-[40px] h-[40px] rounded-full text-ink-pink md:text-white text-[13px] font-medium whitespace-nowrap shrink-0 transition-opacity",
        "border border-solid border-ink-pink bg-white  md:hover:bg-ink-pink/10 md:border-0 transition-all",
        isLoading
          ? "!opacity-100 !bg-ink-pink/10 animate-pulse cursor-not-allowed"
          : "opacity-100",
        !allowSummarization && "!cursor-not-allowed opacity-50"
      )}
      onClick={(e) => {
        e.stopPropagation();
        if (!allowSummarization) return;
        if (!isLoading) onSummarise?.(url);
      }}
      disabled={isLoading}
    >
      <Image
        src={"https://assets.smartkarma.com/icons/sparkle.svg"}
        alt="Sparkle"
        width={20}
        height={20}
      />
    </button>
  );
};

export default SummariseButton;
